export const DateViewMode = {
  fullMonth: 'fullMonth',
  weccPreschedule: 'preschedule',
  weccRealtime: 'realtime'
};